
(function containerTypeDefinition() {
    'use strict';
    angular.module('Entities')
        .service('adminContainerTypeService', [
            'restUrlBuilder', 'config', '$filter', '$q', 'storage', function containerTypeService(restUrlBuilder, config, $filter, $q, storage) {

                this.getById = function getById(id, detailLevel) {
                    var params = { lod: detailLevel };

                    return restUrlBuilder.one('adminContainerTypes', id)
                        .get({ params: params });
                };

                this.getByOrganizationalUnit = function (organizationalUnitId) {

                    var params = { OrganizationalUnitId: organizationalUnitId, applicationId: config.appId(), LevelOfDetail: 2 };

                    return restUrlBuilder.all('adminContainerTypes')
                        .get({ params: params });
                };

                this.getMetadataMappings = function (organizationalUnitId, systemName) {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    var params = {
                        SystemName: systemName,
                        OrganizationalUnitId: organizationalUnitId,
                        applicationId: config.appId()
                    };

                    var builder = new restUrlBuilder('cpp');

                    builder.all('containerTypeMappings')
                        .get({ params: params }).then(function (result) {
                            defered.resolve(result);
                        }, function (error) {
                            defered.reject(error);
                        });

                    return promise;
                };

                this.setMetadataMappings = function (mappings) {
                    mappings.applicationId = config.appId();

                    var builder = new restUrlBuilder('cpp');

                    return builder.all('containerTypeMappings')
                        .put(mappings);
                };

                this.get = function get(name, organizationalUnitId) {

                    var params = { Name: name, OrganizationalUnitId: organizationalUnitId, applicationId: config.appId() };

                    return restUrlBuilder.all('adminContainerTypes')
                        .get({ params: params });
                };

                this.getNotInRole = function (roleId) {
                    var params = { NotInRole: roleId, applicationId: config.appId() };
                    return restUrlBuilder.all('adminContainerTypes')
                        .get({ params: params });
                };

                this.getRoleContainerTypes = function getRoleContainerTypes(roleId) {

                    return restUrlBuilder.one('roles', roleId)
                                         .all('adminContainerTypes')
                                         .get();
                };

                this.setRoleContainerTypes = function setRoleContainerTypes(roleId, containerTypes) {

                    return restUrlBuilder.one('roles', roleId)
                                         .all('adminContainerTypes')
                                         .put(containerTypes);
                };
            }
        ]);

})();